import getBucketsFromChildren from "../../Experiment/getBucketsFromChildren";
import { initializeExperimentState, assignBucket } from "../../Experiment/RegisterExperiment";
import { Cookies } from "../../services";
import { getIdentifierFromAuthToken } from "../../utilities";
import ExperimentBucketApi from "../../services/ExperimentBucketApi";

const registerBcidWithAltIdExperiment = async (props, updateExperiment) => {
  const {
    name,
    children,
    experiments,
    defaultBucket,
    serverCookies,
    identifier
  } = props;

  const buckets = children ? getBucketsFromChildren(children) : [];
  const existingExperiment = experiments[name];

  experiments[name] = initializeExperimentState(defaultBucket, buckets, experiments[name]);
  updateExperiment(name, experiments);

  const preloadedBucket = Cookies.get(name) || serverCookies[name];

  if (preloadedBucket) {
    experiments[name] = assignBucket(preloadedBucket, experiments[name]);
    return updateExperiment(name, experiments, false);
  }

  if (!existingExperiment) {
    const identifierToUse = identifier || getIdentifierFromAuthToken();
    const experimentOptions = { ...props, identifier: identifierToUse };
    const { assignedBucket } = await ExperimentBucketApi.getBcidWithAltIdExperimentBucket(experimentOptions);
    const hasErrored = !assignedBucket;
    experiments[name] = assignBucket(assignedBucket || defaultBucket, experiments[name], hasErrored);
  }

  return updateExperiment(name, experiments);
};

export default registerBcidWithAltIdExperiment;
